/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBankAccess from './blood-bank-access';
import BloodBankAccessDetail from './blood-bank-access-detail';
import BloodBankAccessUpdate from './blood-bank-access-update';
import BloodBankAccessDeleteDialog from './blood-bank-access-delete-dialog';

const BloodBankAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBankAccess />} />
    <Route path="new" element={<BloodBankAccessUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankAccessDetail />} />
      <Route path="edit" element={<BloodBankAccessUpdate />} />
      <Route path="delete" element={<BloodBankAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankAccessRoutes;
